import {Component, Injector} from '@angular/core';
import {mergeAll, Observable, of, switchMap, takeUntil} from 'rxjs';
import {catchError, delay, repeat} from "rxjs/operators";
import {PlayerContainer} from "../../player/player.container";


@Component({
  selector: 'app-label-queue',
  template: '<div #component><template #playercontainer></template></div>',
  styleUrls: []
})
export class LabelQueueComponent extends PlayerContainer {
  index = 0;
  pages;
  defaultDuration;
  duration;

  constructor(protected  injector: Injector) {
    super(injector);
  }

  load(playerObject: any): Observable<any> {
    let self;
    return super.load(playerObject).pipe(
      switchMap( playerBase => {
        self = playerBase;
        this.index = 0;
        this.scaleX = this.parentPlayer.scaleX;
        this.scaleY = this.parentPlayer.scaleY;

        if (this.editMode) {
          return this.showPage();
        }

        return of('loop').pipe(
          switchMap(r1 => this.showPage()),
          switchMap( a=> {
            return of('a').pipe(delay(this.duration))
          }),
          repeat()
        )
      }),
      catchError(err => this.logError(err)),
      switchMap( a => of(self) ),
      takeUntil(this.finish$)
    )
  }

  getPage(): Observable<any> {
    return new Observable<any>( sub => {
      this.defaultDuration = Number(this.data.LabelQueue[0].$.duration);
      this.pages = this.data.LabelQueue[0].TextList[0].Text;
      if (this.pages==null || this.pages.length==0) {
        this.showMsg(this.playerObject.$.label, 'LabelQueue is empty');
        sub.next(null);
        sub.complete();
      } else {
        this.showMsg(null, null);
        const page = this.pages[this.index];
        let duration = page.$.duration;
        if (duration == "") {
          duration = this.defaultDuration;
        }
        this.duration = Number(duration * 1000);

        const text = page.$.text;
        const font = this.data.LabelQueue[0].Font[0].$;
        const layout = this.data.Layout[0].$;


        const player: any = {"$": {"player": "3241", "label": "Label", "autoScaling": "1"}};
        player.Data = [
          {
            "Layout": [
              {
                "$": {
                  "rotation": "0",
                  "x": "0",
                  "y": "0",
                  "width": layout.width,
                  "height": layout.height,
                }
              }
            ],
            "Label": [
              {
                "Text": [text],
                "Font": [{"$": font}]
              }
            ]
          }
        ]

        this.index++;
        if (this.index >= this.pages.length) {
          this.index = 0;
        }
        sub.next(player);
        sub.complete();
      }
    })
  }

}

